import React, { useState } from 'react';
import { FiTrash2, FiCheck } from 'react-icons/fi';
import { storage, db } from '../firebase.config';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { collection, addDoc } from 'firebase/firestore';

const LabsBuilder = () => {
  const [chapterName, setChapterName] = useState('');
  const [questions, setQuestions] = useState([{ imageUrl: '', answer: '' }]);
  const [imageUpload, setImageUpload] = useState(null);

  const handleChapterNameChange = (e) => {
    setChapterName(e.target.value);
  };

  const handleAnswerChange = (index, e) => {
    const newQuestions = [...questions];
    newQuestions[index].answer = e.target.value;
    setQuestions(newQuestions);
  };

  const handleImageUpload = (index, e) => {
    const file = e.target.files[0];
    setImageUpload(file);
    uploadImage(file, index);
  };

  const uploadImage = (file, index) => {
    if (!file) return;

    const timestamp = new Date().getTime();
    const uniqueFileName = `${file.name}_${timestamp}`;

    const storageRef = ref(storage, `images/${uniqueFileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Progress function ...
      },
      (err) => console.log(err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          const newQuestions = [...questions];
          newQuestions[index].imageUrl = url;
          setQuestions(newQuestions);
          setImageUpload(null);
        });
      }
    );
  };

  const handleAddQuestion = () => {
    setQuestions([...questions, { imageUrl: '', answer: '' }]);
  };

  const handleDeleteQuestion = (questionIndex) => {
    const newQuestions = [...questions];
    newQuestions.splice(questionIndex, 1);
    setQuestions(newQuestions);
  };

  const handleSubmit = async () => {
    const questionsCollection = collection(db, 'questions');
    const quizData = { chapterName, questions };
    await addDoc(questionsCollection, quizData);
    alert('Quiz added successfully!');
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="w-4/5 p-8 bg-white shadow-lg rounded-lg">
        <div className="mb-4">
          <label htmlFor="chapterName" className="block font-bold mb-1">
            Chapter Name
          </label>
          <input
            type="text"
            id="chapterName"
            value={chapterName}
            onChange={handleChapterNameChange}
            className="border border-gray-400 p-2 w-full rounded-md"
          />
        </div>
        <h1 className="text-2xl font-bold mb-4 text-center">Quiz Builder</h1>
        {questions.map((question, questionIndex) => (
          <div key={questionIndex} className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-lg font-bold">Question {questionIndex + 1}</h2>
              <button
                onClick={() => handleDeleteQuestion(questionIndex)}
                className="bg-red-500 text-white p-2 rounded hover:bg-red-600"
              >
                <FiTrash2 className="text-white" />
              </button>
            </div>
            <div className="mb-2">
              <label htmlFor={`image-${questionIndex}`} className="block font-bold mb-1">
                Image
              </label>
              <input
                type="file"
                id={`image-${questionIndex}`}
                onChange={(e) => handleImageUpload(questionIndex, e)}
                className="border border-gray-400 p-2 w-full rounded-md"
              />
              {question.imageUrl && (
                <div className="flex items-center mt-2">
                  <FiCheck className="text-blue-500 mr-2" />
                  <span>Image uploaded successfully</span>
                </div>
              )}
            </div>
            <div className="mb-2">
              <label htmlFor={`answer-${questionIndex}`} className="block font-bold mb-1">
                Answer
              </label>
              <input
                type="text"
                id={`answer-${questionIndex}`}
                value={question.answer}
                onChange={(e) => handleAnswerChange(questionIndex, e)}
                className="border border-gray-400 p-2 w-full rounded-md"
              />
            </div>
          </div>
        ))}
        <button
          onClick={handleAddQuestion}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 block mx-auto mb-4"
        >
          Add Question
        </button>
        <button
          onClick={handleSubmit}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 block mx-auto"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default LabsBuilder;